import { stringifyEntityRef } from '@backstage/catalog-model';
import type { TemplateEntityV1beta3 } from '@backstage/plugin-scaffolder-common';
import { datadogRum } from '@datadog/browser-rum';

/** Datadog RUM action name for Create template card selection. */
export const SCAFFOLDER_TEMPLATE_SELECTED_ACTION = 'scaffolder.template_selected';

export type ScaffolderTemplateSelectedContext = {
  template_ref: string;
  template_name: string;
  template_title: string;
  template_namespace: string;
};

/** Build stable RUM context from a scaffolder template entity. */
export function buildScaffolderTemplateSelectedContext(
  template: TemplateEntityV1beta3,
): ScaffolderTemplateSelectedContext {
  const name = template.metadata?.name ?? 'unknown';
  const namespace = template.metadata?.namespace ?? 'default';

  return {
    template_ref: stringifyEntityRef({
      kind: template.kind ?? 'Template',
      namespace,
      name,
    }),
    template_name: name,
    template_title: template.metadata?.title ?? name,
    template_namespace: namespace,
  };
}

/**
 * Record that a user chose a Create template card.
 * Never throws — Create selection must not break if RUM is off or errors.
 */
export function trackScaffolderTemplateSelected(
  template: TemplateEntityV1beta3,
): void {
  try {
    const context = buildScaffolderTemplateSelectedContext(template);
    datadogRum.addAction(SCAFFOLDER_TEMPLATE_SELECTED_ACTION, context);
  } catch (error) {
    // Non-fatal: Create selection must still work if RUM is off or errors.
    // eslint-disable-next-line no-console
    console.warn('Failed to record scaffolder template selection in Datadog RUM', error);
  }
}
